/**
 * 提示弹框组件
 */
import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import './index.less'

export const NoticeTipDialog = (props: { content: string,noIcon?:boolean,onClose:Function }) => {
  const [animateClass, setAnimateClass] = useState('')

  useEffect(() => {
      setAnimateClass('enter')
      let enterTimer = setTimeout(() => {
        setAnimateClass('enter-active')
      })

      setAnimateClass('exit')
      let exitTimer = setTimeout(() => {
        setAnimateClass('exit-active')
      }, 1000)

      let timer = setTimeout(()=>{
        props.onClose()
      },1600)

      return () => {
        clearTimeout(enterTimer)
        clearTimeout(exitTimer)
        clearTimeout(timer)
      }
  }, [])
  
  return ReactDOM.createPortal(
    <>
      <div className={`comm-pop-tips ${animateClass}`}>
        <div className="pop-content">
          <div>
            {props.noIcon ? <></>:(
              <>
               @*<i className="sprite-ico icons-index-success"></i>*@
              </>
            )}
            <p>{props.content}</p>
          </div>
        </div>
      </div>
    </>,
    document.body
  )
}
